import dayjs from "dayjs";
import router from "@/router/pc/index";

//日期时间格式化 （年-月-日 时:分:秒）
let getMyDate = time => {
  if (typeof time == "undefined") {
    return "";
  }
  var oDate = new Date(time),
    oYear = oDate.getFullYear(),
    oMonth = oDate.getMonth() + 1,
    oDay = oDate.getDate(),
    oHour = oDate.getHours(),
    oMin = oDate.getMinutes(),
    oSen = oDate.getSeconds(),
    oTime =
      oYear + "-" + getzf(oMonth) + "-" + getzf(oDay) + " " + getzf(oHour) + ":" + getzf(oMin) + ":" + getzf(oSen); //最后拼接时间
  return oTime;
};
let getzf = num => {
  if (parseInt(num) < 10) {
    num = "0" + num;
  }
  return num;
};

function formatDate (date, fmt) {
  if (!date) return null;
  return dayjs(date).format(fmt);
}
// 投保流程判断用户是否登录
function checkLoginWay () {
  return new Promise((resolve, reject) => {
    let token = localStorage.getItem("token");
    if (!token) {
      router.push({ name: "Login" });
      reject();
      return;
    }
    resolve();
  });
}
function logout () {
  localStorage.removeItem("token");
  window.vue.$bus.emit("add-todo");
  router.push({ name: "Login" });
}
//火狐浏览器跳转链接方法
function open (href) {
  var a = document.createElement("a");
  a.setAttribute("href", href);
  a.setAttribute("target", "_blank");
  // document.body.appendChild(a);
  a.click();
  a.remove();
}

function redirectOpenPage (url) {
  if (url.includes("https") || url.includes("http")) return url;
  return "//" + url;
}

// 信息披露链接处理显示
function getInformationUrl (url) {
  if (url) {
    return url.replace(/\{|}/g, "");
  }
}

// 信息披露链接处理跳转
function getInformation (url) {
  if (url.includes("{")) {
    var _str = url.match(/\{(.+?)\}/g);
		// RegExp 是javascript中的一个内置对象，为正则表达式。
		// RegExp.$1是RegExp的一个属性,指的是与正则表达式匹配的第一个 子匹配(以括号为标志)字符串
		return RegExp.$1
  } else {
    return;
  }
}

export {
  getMyDate,
  getzf,
  formatDate,
  checkLoginWay,
  logout,
  open,
  redirectOpenPage,
  getInformationUrl,
  getInformation,
};



// WEBPACK FOOTER //
// ./src/utils/tool.js